// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1DzNG","messages":"Chat_messages__3_KZ9","dateDivider":"Chat_dateDivider__2-Uil"};